
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 9.75\" id=\"icon-chevron-down\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M15.866,2.074L8.324,9.617c-0.045,0.044-0.097,0.078-0.152,0.1C8.117,9.739,8.059,9.75,8,9.75\r\n\tc-0.117,0-0.234-0.044-0.324-0.134L6.383,8.324c0,0,0-0.001-0.001-0.001L0.134,2.074c-0.178-0.179-0.178-0.468,0-0.646l1.293-1.293\r\n\tc0.178-0.179,0.467-0.179,0.646,0L8,6.06l5.926-5.926c0.179-0.179,0.468-0.179,0.647,0l1.293,1.293\r\n\tC16.044,1.605,16.044,1.895,15.866,2.074z\"/> </symbol>";
module.exports = sprite.add(image, "icon-chevron-down");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/chevron-down.svg
 ** module id = 156
 ** module chunks = 24
 **/